
import React from "react";
import { Table, TableBody } from "@/components/ui/table";
import { Loader2 } from "lucide-react";
import { UserTableHeader, SortField, SortDirection } from "./UserTableHeader";
import { UserRow, UserProfile } from "./UserRow";
import { EmptyState } from "./EmptyState";

interface UserTableProps {
  users: UserProfile[] | undefined;
  isLoading: boolean;
  sortField: SortField;
  sortDirection: SortDirection;
  handleSort: (field: SortField) => void;
  onEditUser: (user: UserProfile) => void;
  onDeleteUser: (user: UserProfile) => void;
  searchQuery: string;
  activeTab: "all" | "admin" | "vendor" | "user" | "invitations";
}

export const UserTable: React.FC<UserTableProps> = ({
  users,
  isLoading,
  sortField,
  sortDirection,
  handleSort,
  onEditUser,
  onDeleteUser,
  searchQuery,
  activeTab,
}) => {
  if (isLoading) {
    return (
      <div className="bg-white rounded-lg shadow overflow-hidden mt-4">
        <Table>
          <UserTableHeader 
            sortField={sortField} 
            sortDirection={sortDirection} 
            handleSort={handleSort} 
          />
          <TableBody>
            <tr>
              <td colSpan={4} className="text-center py-8">
                <div className="flex justify-center items-center">
                  <Loader2 className="h-6 w-6 animate-spin mr-2" />
                  <span>Loading users...</span>
                </div>
              </td>
            </tr>
          </TableBody>
        </Table>
      </div>
    );
  }

  if (!users || users.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow overflow-hidden mt-4">
        <Table>
          <UserTableHeader 
            sortField={sortField} 
            sortDirection={sortDirection} 
            handleSort={handleSort} 
          />
          <TableBody>
            <EmptyState searchQuery={searchQuery} activeTab={activeTab} />
          </TableBody>
        </Table>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden mt-4">
      <Table>
        <UserTableHeader 
          sortField={sortField} 
          sortDirection={sortDirection} 
          handleSort={handleSort} 
        />
        <TableBody>
          {users.map((user) => (
            <UserRow 
              key={user.id} 
              user={user} 
              onEditUser={onEditUser} 
              onDeleteUser={onDeleteUser} 
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
